if (!customElements.get('fluffstyle-choice-recap')) {
  customElements.define(
    'fluffstyle-choice-recap',
    class FluffstyleChoiceRecap extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;

        this.onChange = this.update.bind(this);
        this.productInfo.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onChange);
      }

      update() {
        const rows = this.querySelectorAll('[data-option-position]');
        const optionGroups = [
          ...this.productInfo.querySelectorAll('variant-selects .product-form__input'),
        ];

        rows.forEach((row) => {
          const position = Number(row.dataset.optionPosition) - 1;
          const group = optionGroups[position];
          const value = group?.querySelector('input[type="radio"]:checked')?.value || group?.querySelector('select')?.value;
          const output = row.querySelector('dd');
          if (output && value) output.textContent = value;
        });
      }
    }
  );
}
